module.exports = __webpack_public_path__ + "static/kids-banner-907aaaddd4c265d646040b0670aadedd.jpg";